import { render } from "./vadvertlistadd.vue?vue&type=template&id=2b151630&scoped=true"
import script from "./vadvertlistadd.vue?vue&type=script&lang=js"
export * from "./vadvertlistadd.vue?vue&type=script&lang=js"

import "./vadvertlistadd.vue?vue&type=style&index=0&id=2b151630&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b151630"]])

export default __exports__